import React from "react";
import { Link } from "react-router-dom";

/**
 * Defines the type of configuration object
 * that can be passed to LinkComponent.
 */

/**
 * This is a reusable & flexible Link component, that speeds up application development.
 *
 * @remarks
 * This component contains react-router-dom's Link component in its core.
 *
 * @param param0
 * @returns The react-router-dom's Link component with appropriate key value pairs.
 */
const LinkComponent = ({
  children,
  nativeBehavior,
  reloadDocument,
  to,
  handoverProps,
  preventScrollReset,
  className,
  type,
  size,
  disabled,
  target
}) => {
  className = className ? className : "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, nativeBehavior ? /*#__PURE__*/React.createElement("a", {
    href: to,
    className: `${className}${getLinkTypeStyle(type)}${getDisabledStyle(disabled)}${getLinkBaseFontSizeStyle(size)} customizable`,
    target: target
  }, children) : /*#__PURE__*/React.createElement(Link, {
    to: to,
    state: handoverProps,
    preventScrollReset: preventScrollReset,
    reloadDocument: reloadDocument,
    className: `${className}${getLinkTypeStyle(type)}${getDisabledStyle(disabled)}${getLinkBaseFontSizeStyle(size)} customizable`
  }, children));
};

/**
 *
 * @param type
 * @returns
 */
const getLinkTypeStyle = type => {
  switch (type) {
    case "primary":
      return " text-purple-600 hover:text-purple-800";
    case "secondary":
      return " text-gray-600 hover:text-gray-700";
    default:
      return "";
  }
};

/**
 *
 * @param size
 * @returns
 */
const getLinkBaseFontSizeStyle = size => {
  switch (size) {
    case "sm":
      return " text-sm";
    case "md":
      return " text-base";
    case "lg":
      return " text-lg";
    default:
      return "";
  }
};
const getDisabledStyle = disabled => {
  switch (disabled) {
    case true:
      return " text-gray-300 pointer-events-none";
    default:
      return "";
  }
};
export { LinkComponent };